import { render, staticRenderFns } from "./HomeRealtime.vue?vue&type=template&id=b77568b6&"
import script from "./HomeRealtime.vue?vue&type=script&lang=js&"
export * from "./HomeRealtime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports